import { timeframeBias, type PivotPoint } from './structureBias3';

export type PricedPivot = { label: string; price: number; atUtc: string };
export type RoomFrame = { highs: PivotPoint[]; lows: PivotPoint[]; latestHigh?: PricedPivot | null; latestLow?: PricedPivot | null };

export function structureRoom(frame: RoomFrame, price: number | null, stale: boolean) {
  const bias = timeframeBias(frame.highs, frame.lows);
  const high = frame.latestHigh;
  const low = frame.latestLow;
  if (price === null || !Number.isFinite(price)) return { bias, status: 'Waiting for a market price', high, low };
  const toHigh = high && Number.isFinite(high.price) ? high.price - price : null;
  const aboveLow = low && Number.isFinite(low.price) ? price - low.price : null;
  const between = toHigh !== null && aboveLow !== null && toHigh >= 0 && aboveLow >= 0
    && high!.price > low!.price;
  // Require two completed matching high segments and two completed matching
  // low segments; the latest pair alone can still be a short-lived flip.
  const direction = bias === 'bullish' && high?.label === 'HH' && low?.label === 'HL' ? 'bullish'
    : bias === 'bearish' && high?.label === 'LH' && low?.label === 'LL' ? 'bearish' : null;
  const risk = between ? direction === 'bullish' ? aboveLow : direction === 'bearish' ? toHigh : null : null;
  const room = between ? direction === 'bullish' ? toHigh : direction === 'bearish' ? aboveLow : null : null;
  const ratio = !stale && risk !== null && room !== null && risk > 0 ? room / risk : null;
  const status = stale ? 'Last known price — waiting for a fresh desktop update'
    : toHigh === null || aboveLow === null ? 'Waiting for both confirmed pivots'
    : !between ? 'Price is outside the last confirmed swing range'
    : direction === null ? 'Mixed pivots — distances shown, no directional ratio'
    : 'available';
  return { bias, direction, status, high, low, toHigh, aboveLow, risk, room, ratio };
}
